// عرض عناصر الفاتورة مباشرة من بيانات الـ response بدون أي طلبات إضافية

interface InvoiceItemDisplayProps {
  item: {
    id: number;
    price: number;
    subscription?: number | null;
    service?: number | null;
    service_info?: { image?: string; name?: string } | null;
    subscription_info?: { image?: string; name?: string } | null;
  };
}

const InvoiceItemDisplay = ({ item }: InvoiceItemDisplayProps) => {
  // استخدم البيانات المباشرة من response فقط
  const icon = item.service_info?.image || item.subscription_info?.image;
  const name = item.service_info?.name || item.subscription_info?.name || "صنف";

  return (
    <div className='border-2 border-red-300 rounded-xl p-4 flex flex-col items-center justify-between text-center space-y-2'>
      {icon ? (
        <img
          src={icon}
          alt={name}
          className='w-14 h-14 mb-2 object-contain'
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = "none";
          }}
        />
      ) : (
        <span className='text-4xl mb-2'>
          {item.service ? "🚗" : item.subscription ? "📅" : "📦"}
        </span>
      )}

      <div className='flex flex-col space-y-1'>
        <span className='text-base font-bold'>{name}</span>
        <span className='text-red-600 text-lg'>
          {Number(item.price).toFixed(2)} ريال
        </span>
      </div>
    </div>
  );
};

export default InvoiceItemDisplay;
